export default __webpack_public_path__ + "static/media/output.46f33ede.svg";